/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebhookEventDto } from '../../models/webhook-event-dto';
import { WebhookEventFilter } from '../../models/webhook-event-filter';

export interface WebhooksMonitoringEventsPost$Json$Params {
      body?: WebhookEventFilter
}

export function webhooksMonitoringEventsPost$Json(http: HttpClient, rootUrl: string, params?: WebhooksMonitoringEventsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookEventDto>>> {
  const rb = new RequestBuilder(rootUrl, webhooksMonitoringEventsPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WebhookEventDto>>;
    })
  );
}

webhooksMonitoringEventsPost$Json.PATH = '/webhooks/monitoring/events';
